export default class Music
{
    constructor()
    {
        this.tracks = [
            './sounds/music/1. Motivo de Clarinete.mp3',
            './sounds/music/2. Menu Motif.mp3',
            './sounds/music/3. Quiet Exploration.mp3',
            './sounds/music/4. Gentle Motif.mp3',
            './sounds/music/5. Wistful Counter-Melody.mp3',
            './sounds/music/6. Unite 2.0 chill game.mp3'
        ]
        this.trackIndex = 0
        this.audio = new Audio()
        this.audio.preload = 'none'
        this.audio.volume = 0.2
        this.start = this.start.bind(this)

        this.audio.addEventListener('ended', () => this.playNext())
        this.setUnlockListeners()
    }

    setUnlockListeners()
    {
        window.addEventListener('pointerdown', this.start)
        window.addEventListener('keydown', this.start)
    }

    start()
    {
        if(!this.audio.src)
            this.setNextTrack()

        this.audio.play()
            .then(() =>
            {
                window.removeEventListener('pointerdown', this.start)
                window.removeEventListener('keydown', this.start)
            })
            .catch(() => {})
    }

    toggle()
    {
        if(this.audio.paused)
            this.start()
        else
            this.audio.pause()
    }

    setVolume(_value)
    {
        this.audio.volume = Math.min(1, Math.max(0, _value))
    }

    playNext()
    {
        this.setNextTrack()
        this.audio.play().catch(() => this.setUnlockListeners())
    }

    setNextTrack()
    {
        this.audio.src = this.tracks[this.trackIndex]
        this.trackIndex = (this.trackIndex + 1) % this.tracks.length
    }
}
